import { useEffect, useState, useCallback } from "react";
import { api, fmtDate, money } from "../lib/api";
import { useTier, TIER_ORDER, TIER_META } from "../lib/tiers";
import { TierSwitch } from "../components/TierSwitch";
import { MembershipPanel } from "../components/MembershipPanel";
import { FounderCard } from "../components/FounderCard";
import { ComplianceGate } from "../components/ComplianceGate";
import { AliasCard } from "../components/AliasCard";
import { PrivacyCard } from "../components/PrivacyCard";
import { ReviewsCard, EmailPrefsCard } from "../components/MemberExtras";

export default function Dashboard() {
  const [d, setD] = useState(null);
  const [tier, setTier] = useTier();
  const load = useCallback(() => api.get("/me/status").then((r) => setD(r.data)), []);
  useEffect(() => { load(); }, [load]);
  if (!d) return <div className="pt-40 text-center text-slate-500 font-mono-lux text-sm">Loading…</div>;

  const mine = TIER_ORDER.filter((t) => d.tiers[t].membership?.status === "active");
  const offers = TIER_ORDER.filter((t) => d.tiers[t].pending_offer);

  return (
    <div className="max-w-7xl mx-auto px-5 md:px-10 pt-32 pb-24">
      <p className="eyebrow">Welcome, {d.user.name.split(" ")[0]}</p>
      <h1 className="font-serif-lux text-4xl sm:text-5xl mt-3">Your spots in line</h1>
      <p className="text-sm text-slate-500 mt-2">Your positions are private — other members can't see where you are.</p>
      {offers.length > 0 && (
        <p data-testid="offer-alert" className="mt-4 text-sm text-[#38BDF8]">You have a trip offer waiting in: {offers.map((t) => TIER_META[t].short).join(", ")}</p>
      )}
      <ComplianceGate info={d.compliance} onDone={load} />
      <AliasCard alias={d.user?.alias} onDone={load} />
      <FounderCard promo={d.promo} />
      <TierSwitch value={tier} onChange={setTier} mine={mine} className="mt-8" />
      <MembershipPanel key={tier} tier={tier} data={d.tiers[tier]} ts={d.stats[tier]} promo={d.promo} charities={d.charities} awards={d.awards} onDone={load} />

      <div className="mt-10 lux-card p-6 md:p-8" data-testid="member-payments">
        <p className="eyebrow">Payment history · all lines</p>
        <div className="mt-4 divide-y divide-white/5 max-h-80 overflow-y-auto">
          {d.payments.map((p) => (
            <div key={p.id} className="grid grid-cols-2 md:grid-cols-4 gap-2 py-3 text-sm">
              <span className="text-slate-300 capitalize">{p.kind.replace("_", " ")}{p.discounted && " (autopay)"}</span>
              <span className="text-slate-500 text-xs md:text-sm">{TIER_META[p.tier]?.short}</span>
              <span className="font-mono-lux text-slate-400">{fmtDate(p.created_at)}</span>
              <span className="font-mono-lux md:text-right">{money(p.amount)}</span>
            </div>
          ))}
          {d.payments.length === 0 && <p className="py-4 text-sm text-slate-500">No payments yet.</p>}
        </div>
      </div>
      <PrivacyCard />
      <ReviewsCard />
      <EmailPrefsCard />
    </div>
  );
}
